import script from "./select-sensor.vue?vue&type=script&lang=ts&setup=true"
export * from "./select-sensor.vue?vue&type=script&lang=ts&setup=true"

import "./select-sensor.vue?vue&type=style&index=0&id=1647328e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1647328e"]])

export default __exports__